/**
 * Громкость канала у клиента.
 *
 * Отдельно от сцены, и по той же причине, что источники эмбедов:
 * громкость живёт на КАНАЛЕ, а не на сцене. Сцену переключают,
 * а звук при переключении меняться не должен.
 *
 * Разбор общий для оверлея и панели: первый применяет значения
 * к графу, вторая рисует по ним ползунок. Две реализации разошлись
 * бы на первой правке, и расхождение выглядело бы как «в панели одно,
 * в эфире другое» — то есть как поломка, которую ищут где угодно.
 */
/** Что канал говорит о своей громкости. */
import { decodeMessage } from './message.js';
/** Полная громкость: столько по умолчанию у нового канала. */
export const FULL_AUDIO = { master: 1, ceiling: 1 };
/**
 * Разбирает сообщение `audio`.
 *
 * Возвращает null для всего остального: вызывающий по этому
 * понимает, что сообщение не про громкость, и передаёт дальше.
 *
 * ЗНАЧЕНИЯ ПРИЖИМАЮТСЯ ЗДЕСЬ. Они приходят из сети, а дальше
 * попадают в узел Web Audio: NaN и бесконечность там дают не тишину,
 * а треск в наушниках у зрителей.
 */
export function parseAudio(raw) {
    const parsed = decodeMessage(raw);
    if (parsed === null)
        return null;
    const message = parsed;
    if (message.t !== 'audio')
        return null;
    const ceiling = level(message.ceiling, 1);
    return {
        ceiling,
        // Уровень не бывает выше потолка НИ В КАКОМ виде, включая
        // пришедший по сети: это и есть «ни через какой путь»
        // из постановки задачи
        master: Math.min(level(message.master, 1), ceiling),
    };
}
function level(value, fallback) {
    if (typeof value !== 'number' || !Number.isFinite(value))
        return fallback;
    return Math.min(1, Math.max(0, value));
}
//# sourceMappingURL=audio.js.map